import { t } from '@lingui/core/macro';
import { MetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const governingLawFilterLabel = () => t({ message: 'Governing law', comment: 'Insights filter: Governing law' });
export function GoverningLawFilter() {
    return (<MetadataAllowedValuesFilter name="GoverningLaw" field="metadataDocumentGoverningLaw" label={governingLawFilterLabel()}/>);
}
